
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.01 2C2.01 0.9 2.9 0 4 0H11.17C11.7 0 12.21 0.21 12.58 0.59L17.41 5.42C17.79 5.79 18 6.3 18 6.83V18C18 19.1 17.1 20 16 20H3.99C2.89 20 2 19.1 2 18L2.01 2ZM11 1.49969V5.9997C11 6.5497 11.45 6.99969 12 6.99969H16.5L11 1.49969Z"}})])
          )
        }
      }
    